module.exports = __webpack_public_path__ + "video/300_HC_2023_What_Is_Security_Awareness.d7c1e034.vtt";